import { Model } from 'core/models';
import { Status } from 'models/Status';

export class Currency extends Model
{
    public id?: number;

    public code?: string;

    public name?: string;

    public exchangeRate?: number;

    public statusId?: number = 1;

    public status?: Status;
}
